export var QuestionType;

(function (QuestionType) {
  QuestionType["comment"] = "comment";
  QuestionType["text"] = "text";
  QuestionType["radiogroup"] = "radiogroup";
  QuestionType["dropdown"] = "dropdown";
  QuestionType["matrixdynamic"] = "matrixdynamic";
  QuestionType["date"] = "date";
  QuestionType["divider"] = "divider";
  QuestionType["title"] = "title";
})(QuestionType || (QuestionType = {}));

export var OperatorType;

(function (OperatorType) {
  OperatorType["equal"] = "==";
  OperatorType["notEqual"] = "!=";
  OperatorType["greaterThan"] = ">";
  OperatorType["lessThan"] = "<";
  OperatorType["greaterThanOrEqualTo"] = ">=";
  OperatorType["lessThanOrEqualTo"] = "<=";
})(OperatorType || (OperatorType = {}));

export var FormVariant;

(function (FormVariant) {
  FormVariant["oneLine"] = "one-line";
  FormVariant["twoLine"] = "two-line";
  FormVariant["AlignRight"] = "align-right";
})(FormVariant || (FormVariant = {}));